import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { LoadBalancerPortInput } from "../../../schema/types/workload/input";
import { store } from "../../../store";
import { formSet, formSetValue, formTriggerValidation } from "../../gvc/testNewForm/utils";
import { FormListFieldItem } from "../../gvc/formListFieldItem";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpInputNumber } from "../../gvc/testNewForm/CpInputNumber";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: LoadBalancerPortInput;
  index?: number;
}
export const CpArrayItemLoadBalancerPort: React.FC<Props> = React.memo(
  ({ name: _name, item: _item, index: _index }) => {
    const { id } = useCpFormContext();

    const name = _name!;
    const item = _item!;
    const index = _index!;

    function remove() {
      const form = store.getState().form.instances[id];
      const values = form.values;
      const items = get(values, name) || [];
      let _items = cloneDeep(items);
      _items = _items.filter((i) => i.id !== item.id);
      formSetValue(id, name, _items);

      formTriggerValidation(id);
    }

    return (
      <FormListFieldItem columnCount={4} hasRemoveButton className="mb-1">
        <CpInputNumber name={`${name}.${index}.externalPort`} className="free-width w-full" />
        <CpSelect
          name={`${name}.${index}.protocol`}
          options={[
            { label: "TCP", value: "TCP" },
            { label: "UDP", value: "UDP" },
          ]}
        />
        <CpInputNumber name={`${name}.${index}.containerPort`} className="free-width w-full" />
        <CpSelect
          name={`${name}.${index}.scheme`}
          options={[
            { label: "http", value: "http" },
            { label: "https", value: "https" },
            { label: "tcp", value: "tcp" },
            { label: "ws", value: "ws" },
            { label: "wss", value: "wss" },
          ]}
        />
        <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
      </FormListFieldItem>
    );
  },
);
